import { ErrorToast } from '@src/components/Toasts'
import axios from 'axios'
import { pathOr } from 'ramda'
import { toast } from 'react-toastify'

export const toastError = (e: unknown) => {
  const error = { message: '' }

  if (axios.isAxiosError(e)) {
    error.message = e.response?.data
    toast.error(<ErrorToast text={e.response?.data.message as string} />)
  } else {
    error.message = (e as Record<string, Error>)?.data.message
    toast.error(<ErrorToast text={pathOr('Something went wrong', ['data', 'message'], e)} />)
  }
  return error
}
